import React, { useState } from "react";
import OptionsButton from "../../components/Common/buttons/OptionsButton";
import { NavLink } from "react-router-dom";
import { ApiHook } from "../../hooks/apiHook";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import EmoneyTiles from "../../components/Emoney/EmoneyTiles";
import EmoneyTable from "../../components/Emoney/EmoneyTable";
import EmoneyTransferOffcanvas from "../../components/Emoney/EmoneyFundTransfer";
import { EwalletService } from "../../services/ewallet/ewallet";
import SilverReportTable from "../../components/silver-report/SilverReportTable";

const SilverReport = () => {
  const [showTransfer, setShowTransfer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { t } = useTranslation();
  const style = {
    position: "absolute",
    inset: "0px auto auto 0px, margin: 0px",
    transform: "translate(190px, 42px)",
  };

  const handleEmoneyTransfer = () => {
    setShowTransfer((prevShowTransfer) => !prevShowTransfer);
  };
  const ewallet = ApiHook.CallEwalletTiles();
  const emoney = EwalletService.useEmoneyTiles();
  const userSelectedCurrency = useSelector(
    (state) => state.user?.selectedCurrency
  );
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );
  const moduleStatus = useSelector(
    (state) => state.dashboard?.appLayout?.moduleStatus
  );
  
  return (
    <>
      <div className="page_head_top">Silver Report</div>
      {/* <div className="ewallet_top_btn_sec">
        <div className="row justify-content-between">
          <div className="col-md-4 text-end">
            <OptionsButton
              title={"request_emoney"}
              handleOpen={handleEmoneyTransfer}
              style={style}
              type={"emoney"}
            />
          </div>
        </div>
      </div> */}
      {/* <EmoneyTiles
        tiles={emoney?.data}
        currency={userSelectedCurrency}
        conversionFactor={conversionFactor}
      /> */}
      <SilverReportTable
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        currency={userSelectedCurrency}
      />
      {/* <EmoneyTransferOffcanvas
        balance={ewallet?.data?.balance}
        show={showTransfer}
        handleClose={handleEmoneyTransfer}
        currency={userSelectedCurrency}
      /> */}
    </>
  );
};

export default SilverReport;
